import { ACCESS_CODES } from 'utils/sitePreferenceHelpers'

export const DIGITAL_WELL_BEING_PRODUCT_NAME = 'digital-well-being'
export const UNIT_ROUTE_PRODUCT_NAMES = [
  'elementary',
  'middle-school',
  DIGITAL_WELL_BEING_PRODUCT_NAME,
]

export const LESSONS_PROGRAM_CONFIG = {
  elementary: {
    instructorKey: 'K5SelDigital',
    activeSiteKey: 'elementaryActiveSiteId',
    preferencesAccessCode: ACCESS_CODES.K5,
  },
  'middle-school': {
    instructorKey: 'MspDigital',
    activeSiteKey: 'middleSchoolActiveSiteId',
    preferencesAccessCode: ACCESS_CODES.MSP,
  },
  [DIGITAL_WELL_BEING_PRODUCT_NAME]: {
    instructorKey: 'Dwb',
    activeSiteKey: 'digitalWellBeingActiveSiteId',
  },
}
